import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaddingHorizontal12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPaddingHorizontal12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 11.002a.5.5 0 0 1-.5-.5V1.5a.5.5 0 0 1 1 0v9.002a.5.5 0 0 1-.5.5M6.955 4.546H5.048a.5.5 0 0 0-.5.5v1.91a.5.5 0 0 0 .5.5h1.907a.5.5 0 0 0 .5-.5v-1.91a.5.5 0 0 0-.5-.5m-.954-1h.954a1.5 1.5 0 0 1 1.5 1.5v1.91a1.5 1.5 0 0 1-1.5 1.5H5.048a1.5 1.5 0 0 1-1.5-1.5v-1.91a1.5 1.5 0 0 1 1.5-1.5zM1 10.5a.5.5 0 1 0 1 0v-9a.5.5 0 0 0-1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPaddingHorizontal12);
